import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import './Nav.css'

const SHIFT = 12


var Nav = Backbone.View.extend({
    el: '.Nav',

    events: {
        'mouseenter .Nav-btn': 'hoverOn',
        'mouseleave': 'hoverOff'
        //'click .Nav-link': 'navigate'
    },

    initialize () {
        _.bindAll(this, 'activate', 'deactivate', 'minimize', 'maximize', 'hoverOn', 'hoverOff')

        this.state = new Backbone.Model({
            minimized: false,
            hovered: false
        })
        this.promise = null

        this.$items = this.$('.Nav-item')
        this.$btn = this.$('.Nav-btn')
        this.$list = this.$('.Nav-list')
        this.$topLine = this.$('.Nav-line--top')
        this.$bottomLine = this.$('.Nav-line--bottom')
    },

    navigate(e) {
        e.preventDefault()

        var url = $(e.target).attr('href')
        app.router.navigate(url, {trigger: 'true'})
    },

    activate (options) {
        if (options && options.fixed) {
            this.$el[0].style.position = 'fixed'
        }

        _.each(this.$items, (item, index) => {
            let index1 = index + 1
            let shift = SHIFT * (-(Math.pow(-1, index1 % 2)))

            $.Velocity.hook(item, 'translateX', shift + 'px')
        })

        $.Velocity.hook(this.$items, 'opacity', '0')

        this.$el[0].style.display = 'block'
        this.$list[0].style.display = 'block'

        this.$items.velocity('stop', true)

        return $.Velocity.animate(this.$items, {
            opacity: [1, 'linear'],
            translateX: [0, 'easeOutCubic']
        }, _.extend({duration: 500}, options))
    },

    deactivate (options) {
        var promise
        var self = this

        this.$items.velocity('stop', true)

        _.each(this.$items, (item, index) => {
            let index1 = index + 1
            let shift = SHIFT * (-(Math.pow(-1, index1 % 2)))

            $.Velocity.hook(item, 'translateX', 0)

            promise = $.Velocity.animate(item, {
                opacity: [0, 'linear'],
                translateX: [shift + 'px', 'easeOutCubic']
            }, _.extend({
                duration: 1000,
                complete() {
                    self.$list.css('display', 'none')
                }
            }, options))
        })

        //$.Velocity.animate(this.$btn[0], {opacity: [0, 'linear']}, _.extend({
        //    duration: 1000,
        //    complete() {
        //        self.$list.css('display', 'none')
        //    }
        //}, options))

        return promise
    },

    maximize(options) {
        var self = this

        $.Velocity.hook(this.$topLine[0], 'translateX', '0px')
        $.Velocity.hook(this.$bottomLine[0], 'translateX', '0px')

        this.state.set('minimized', false)

        this.$topLine.velocity('stop', true)
        this.$bottomLine.velocity('stop', true)

        $.Velocity.animate(this.$topLine[0], {
            translateX: ['100%', 'easeOutQuad']
        }, _.extend({
            duration: 500,
            display: 'none'
        }, options))

        var promise = $.Velocity.animate(this.$bottomLine[0], {
            translateX: ['-100%', 'easeOutQuad']
        }, _.extend({
            duration: 500,
            display: 'none',
            complete() {
                self.$btn[0].style.display = 'none'
                $.Velocity.hook(self.$btn, 'opacity', 0)
            }
        }, options))

        return promise.then(() => {
            if (this.state.get('minimized') === true) {
                return
            }

            this.activate()
        })
    },

    minimize(options) {
        $.Velocity.hook(this.$topLine[0], 'translateX', '100%')
        $.Velocity.hook(this.$bottomLine[0], 'translateX', '-100%')

        this.$btn[0].style.display = 'block'
        $.Velocity.hook(this.$btn, 'opacity', 1)
        this.state.set('minimized', true)

        this.$topLine.velocity('stop', true)
        this.$bottomLine.velocity('stop', true)

        return this.deactivate()
            .then(() => {
                if (this.state.get('minimized') === false) {
                    return
                }

                return $.Velocity.animate([this.$topLine[0], this.$bottomLine[0]], {
                    translateX: [0, 'easeOutQuad']
                }, _.extend({
                    duration: 500,
                    display: 'block'
                }, options))
            })
    },

    hoverOn() {
        this.state.set('hovered', true)
        this.maximize()
    },

    hoverOff() {
        if (this.state.get('hovered')) {
            this.state.set('hovered', false)
            this.minimize()
        }
    }
})

export default Nav


// WEBPACK FOOTER //
// ./assets/app/front/components/Nav/Nav.js